<template>
  <div class="popup-container">
    <van-popup v-model:show="isShowDialog" teleport="body" @click-overlay="handleClose" :style="vanPopupStyle"
      class="mDialog" round>
      <div class="mDialog__content">
        <!-- <div class="mDialog__titleAr" v-if="language === 'ar'">{{ headerText }}</div> -->
        <div class="mDialog__title">{{ headerText }}</div>
        <div class="mDialog__closeAr" @click="handleClose" v-if="language === 'ar'">
          <img fr src="@/assets/img/close.png" alt="close" />
        </div>
        <div class="mDialog__close" @click="handleClose" v-else>
          <img fr src="@/assets/img/close.png" alt="close" />
        </div>
        <div class="mDialog__middle">
          <qr-code class="mDialog__middle--logo" :value="qrCodeUrl" :width="qrCodeWidth"
            :logo="require(`../../assets/img/${qrCodeLogo}`)" />
        </div>
        <div class="mDialog__footer">
          <van-button class="mDialog__footer--button" type="primary" @click="handleClickBtn"
            @touchstart="handleClickBtn">{{ btnText }}
          </van-button>
        </div>
      </div>
      <!-- <div class="mDialog__close" @click="handleClose">
        <img fr src="@/assets/img/ic_icon_pay_out.png" alt="close" />
      </div> -->
    </van-popup>
  </div>
</template>

<script lang='ts'>
import { reactive, toRefs, Ref, PropType, watchEffect, ref, computed, ComputedRef } from 'vue'
import { Popup, Button } from 'vant'
import { useWindowSizeFn } from '@/hooks/useWindowSizeFn'
import { getRequestLanguage } from '@/api/utils'

/**
 * 具体配置参考:
 * https://qr-code-styling.com/
 * https://github.com/scholtz/qrcode-vue3
 */
// import QRCodeVue3 from 'qrcode-vue3'

interface MDialogState {
  isShowDialog: Ref<boolean>
  vanPopupStyle: Ref<object>
  handleClickBtn: () => void
  handleClose: () => void
  language: Ref<string>
  qrCodeWidth: ComputedRef<number>
}
export default {
  name: 'MDialog',
  components: {
    [Popup.name as string]: Popup,
    [Button.name as string]: Button
  },
  props: {
    show: {
      type: Boolean as PropType<boolean>,
      required: true,
      default: false
    },
    style: {
      type: Object as PropType<object>,
      default: () => {
        const minWidth = window.innerHeight < 500 ? '200px' : '320px'
        const maxWidth = window.innerHeight < 500 ? '200px' : '320px'
        return {
          width: '40%',
          minWidth,
          maxWidth,
          overflow: 'visible'
        }
      }
    },
    headerText: {
      type: String as PropType<string>,
      default: '手机扫码下载weelife App'
    },
    btnText: {
      type: String as PropType<string>,
      default: '下载App'
    },
    qrCodeUrl: {
      type: String as PropType<string>,
      default: window.location.href
    },
    qrCodeLogo: {
      type: String as PropType<string>,
      default: 'logo.png'
    },
    onClose: {
      type: Function as PropType<() => void>,
      required: true
    },
    onDownload: {
      type: Function as PropType<() => void>,
      required: true
    }
  },
  setup(
    props: Readonly<{
      show: boolean
      style: object
      onClose: () => void
      onDownload: () => void
    }>
  ): MDialogState {
    const state = reactive<{
      isShowDialog: boolean
      vanPopupStyle: object
    }>({
      isShowDialog: props.show,
      vanPopupStyle: props.style
    })

    const qrCodeWidth = computed(() => {
      if (window.innerHeight < 500) {
        return 110
      } else {
        return 180
      }
    })

    watchEffect(() => {
      state.isShowDialog = props.show
    })

    watchEffect(() => {
      state.vanPopupStyle = props.style
    })

    const contentWeight = ref(window.innerWidth)

    useWindowSizeFn(
      () => {
        contentWeight.value = window.innerWidth
        if (contentWeight.value <= 320) {
          state.vanPopupStyle = {
            minWidth: '280px'
          } as object
        }
      },
      200,
      { immediate: true }
    )

    const handleClickBtn = () => {
      props.onDownload()
    }

    const handleClose = () => {
      props.onClose()
    }

    const language = computed(() => {
      return getRequestLanguage()
    })

    return {
      ...toRefs(state),
      handleClickBtn,
      handleClose,
      language,
      qrCodeWidth
    }
  }
}
</script>
<style lang='scss' scoped>
@include b(mDialog) {
  padding: 10px;

  @include e(title) {
    // width: 90% !important;
    font-size: 30px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 43px;
    color: #262928;
    // margin: 40px 0px 30px 40px;
    text-align: center;
    margin-top: 56px;
    margin-bottom: 20px;
    @include box-clamp(1)
  }

  @include e(content) {
    border-radius: 40px;
    height: 620px;
  }

  @include e(middle) {
    text-align: center;
  }

  @include e(footer) {
    width: 100%;
    padding: 20px 0;
    display: flex;
    align-items: center;
    justify-content: center;

    @include m(button) {
      width: 75%;
      height: 90px;
      border-radius: 50px;
      font-weight: 600;
      background: $btnBg !important;
      border: var(--van-button-border-width) solid $btnBg !important;
      color: $btnText;
    }
  }

  @include e(close) {
    position: absolute;
    width: 35px;
    height: 35px;
    top: 53px;
    right: 40px;
    z-index: 9999;
  }
  @include e(closeAr) {
    position: absolute;
    // left: 45%;
    width: 35px;
    height: 35px;
    top: 53px;
    left: 20px;
    // bottom: -120px;
    z-index: 9999;
  }
}

@media (max-height: 500px) {

  @include b(mDialog) {

    @include e(content) {
      height: 350px;
    }

    @include e(title) {
      font-size: 25px;
      margin: 15px 0px -5px 30px;
    }

    @include e(footer) {
      width: 100%;
      padding: 0px 0;

      @include m(button) {
        width: 60%;
        height: 65px;
        border-radius: 30px;
        font-size: 25px;
      }
    }

    @include e(titleAr) {
      font-size: 25px;
      margin: 15px 15px -5px 0px;
    }

    // @include e(close) {
    //   bottom: -70px;
    //   width: 45px;
    //   height: 45px;
    // }
  }
}
</style>
